export const LOGIN = 'LOGIN';
export const PASSWORD_FORGET = 'PASSWORD_FORGET';
export const REGISTER = 'REGISTER';
export const ACTIVE_ACCOUNT = 'ACTIVE_ACCOUNT';
export const NEW_PASSWORD = 'NEW_PASSWORD';
export const ORDER = 'ORDER';
export const GET_ALL_SITE = 'GET_ALL_SITE';
export const CREATE_SITE = 'CREATE_SITE';
export const EDIT_SITE = 'EDIT_SITE';
export const DATA_EDIT_SITE = 'DATE_EDIT_SITE';